import React from 'react'
import StaticPage from '../components/StaticPage'

function TermsPage() {
  return (
    <StaticPage title="Terms of Service" intro="The terms for using this website">
      <p className="muted">Last updated: August 2026. This is a starting draft. Please review with the club before relying on it.</p>

      <h2>Using this site</h2>
      <p>
        This website is provided by Wingbeat Paragliding Club for information about the club, its
        flying sites, and the local paragliding community. By using the site you agree to these terms.
      </p>

      <h2>Flying information is not advice</h2>
      <p>
        Site guides, wind information, and flight logs are shared in good faith by club members but
        are not a substitute for your own judgement. Paragliding is inherently dangerous. Always
        check current conditions, respect site rules and landowners, and fly within your own limits
        and rating. You are responsible for your own safety.
      </p>

      <h2>Content you submit</h2>
      <p>
        If you submit content (such as flight logs or photos), you confirm it is yours to share and
        you grant the club permission to publish it on this site. Do not post anything unlawful,
        offensive, or that infringes someone else's rights.
      </p>

      <h2>Liability</h2>
      <p>
        We work to keep the information here accurate but cannot guarantee it. To the extent permitted
        by law, the club is not liable for any loss arising from use of this website or the information
        on it.
      </p>

      <h2>Questions</h2>
      <p>
        If anything here is unclear, please <a href="/contact">contact us</a>.
      </p>
    </StaticPage>
  )
}

export default TermsPage
